var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTriangleDownBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "6px",
    viewBox: "0 0 12 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Triangle 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch Beta.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-674 -343)",
    fill: "#001E63"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(317 148)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 151)"
  }, /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(363 47) scale(1 -1) translate(-363 -47)",
    points: "363 44 369 50 357 50"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTriangleDownBlue);
export default __webpack_public_path__ + "static/media/icon-triangle-down-blue.ba9c64ba911a9f4428c4d8d87acfa057.svg";
export { ForwardRef as ReactComponent };